import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR
} from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig';

export const APP_NAME = process.env.REACT_APP_SITE_NAME;
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect';
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/listing-list`;
export const NO_PACKAGE_ENTRY = `${APP_PREFIX_PATH}/dashboards/vendor-cart-list/add-vendor-cart`;
export const UNAUTHENTICATED_ENTRY = '/login';
export const SIGNUP_ENTRY = '/signup';
export const REDIRECT_COMPONENT_KEY = 'dashboard';


export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: 'en',
  navType: NAV_TYPE_SIDE,
  topNavColor: '#3e82f7',
  headerNavColor: '',
  mobileNav: false,
  currentTheme: 'light',
  direction: DIR_LTR,
  blankLayout: false
};
